import React from 'react';

const AnalysisListTable = ({tableData}) => {

  return (
    <div className='table_container iransans'>
      <table>
        <thead>
        <tr>
          <th>ردیف</th>
          <th>کد</th>
          <th>مصاحبه کننده</th>
          <th>مصاحبه شونده</th>
          <th>تاریخ</th>
          <th>عنوان نیاز</th>
        </tr>
        </thead>
        <tbody>
        {tableData ? tableData.map((item, index) => (
          <tr key={index}>
            <td>{index+1}</td>
            <td>{item.id}</td>
            <td>{item.interview1}</td>
            <td>{item.interview2}</td>
            <td>{item.date}</td>
            <td>{item.title}</td>
          </tr>

        )) : null}
        </tbody>
      </table>
    </div>
  );
};

export default AnalysisListTable;